<template>
  <el-form :model="form" :rules="rules" ref="resetForm">
    <!-- 新密码 -->
    <el-form-item :label="$t('avatarSelect.NewPwd')" prop="newPassword">
      <el-input
        v-model="form.newPassword"
        type="password"
        :placeholder="$t('avatarSelect.NewPwd')"
        autocomplete="off"
      />
    </el-form-item>

    <!-- 确认新密码 -->
    <el-form-item :label="$t('avatarSelect.ConfirmNewPassword')" prop="confirmPassword">
      <el-input
        v-model="form.confirmPassword"
        type="password"
        :placeholder="$t('avatarSelect.ConfirmNewPassword')"
        autocomplete="off"
      />
    </el-form-item>

    <!-- 验证方式 Tab -->
    <el-tabs v-model="activeTab" @tab-click="onTabChange">
      <el-tab-pane :label="$t('LoginFields.UserEmailRecover')" name="email">
        <el-form-item :label="$t('avatarSelect.EmailCode')" prop="emailCode" style="display:flex;flex-direction:column;align-items:flex-start;">
          <div style="display:flex;align-items:center;">
              <el-input
                v-model="form.emailCode"
                :placeholder="$t('avatarSelect.EmailCode')"
                style="width: 200px;"
            />
            <el-button
                :disabled="sendingCode"
                @click="sendEmailCode"
                style="margin-left: 10px;"
                type="success"
            >
                {{ sendingCode ? countdown + 's' : $t("RegisterFields.SendCode2") }}
            </el-button>
          </div>
        </el-form-item>
      </el-tab-pane>

      <el-tab-pane :label="$t('LoginFields.UserAuthenticator')" name="authenticator">
        <el-form-item :label="$t('LoginFields.UserAuthenticator')" prop="authCode" style="display:flex;flex-direction:column;align-items:flex-start;">
          <el-input
            v-model="form.authCode"
            :placeholder="$t('LoginFields.UserGoogleAuthInputPlacholder')"
            style="width: 200px;"
          />
        </el-form-item>
      </el-tab-pane>
    </el-tabs>

    <!-- 提交按钮 -->
    <el-form-item style="display:flex;align-items:center;justify-content:flex-end;margin-top:30px;">
        <el-button @click="clickCancel">{{ $t('SubAccount.Cancel') }}</el-button>
        <el-button style="background-color:#00BEA4;color:#fff;border-color:#00BEA4;" @click="submitForm">{{ $t('SubAccount.Submit') }}</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { resetSubAccountPassword } from '@/api/http.js'

export default {
  props: ['subUid'],
  data() {
    return {
      activeTab: 'email',
      sendingCode: false,
      countdown: 60,
      timer: null,
      form: {
        newPassword: '',
        confirmPassword: '',
        emailCode: '',
        authCode: ''
      },
      rules: {
        newPassword: [
          { required: true, message: 'required', trigger: 'blur' },
          {
            pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z!@#$%^&*]{6,}$/,
            message: this.$t('RegisterFields.PasswordTip'),
            trigger: 'blur'
          }
        ],
        confirmPassword: [
          { required: true, message: 'required', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value !== this.form.newPassword) {
                callback(new Error(this.$t('RegisterFields.CRPTip')))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ],
        emailCode: [
        //   { required: true, message: 'required', trigger: 'blur' }
        ],
        authCode: [
        //   { required: true, message: 'required', trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    this.applyVerifyRule()
  },
  methods: {
    applyVerifyRule() {
        if (this.activeTab === 'email') {
        this.rules.emailCode = [
            { required: true, message: 'required', trigger: 'blur' }
        ]
        this.rules.authCode = []

        this.form.authCode = ''
        this.$refs.resetForm?.clearValidate(['authCode'])
        } else {
        this.rules.authCode = [
            { required: true, message: 'required', trigger: 'blur' }
        ]
        this.rules.emailCode = []

        this.form.emailCode = ''
        this.$refs.resetForm?.clearValidate(['emailCode'])
        }

        this.$nextTick(() => {
        this.$refs.resetForm?.clearValidate()
        })
    },
    onTabChange() {
        this.applyVerifyRule()
    },
    sendEmailCode() {
      if (this.sendingCode) return
    //   if (!this.form.newPassword) {
    //     // this.$message.warning('请先填写新密码')
    //     return
    //   }

      this.sendingCode = true
      let data = {
        type: "get_email_code",
        code_type: "reset_pw",
        user_name: window.localStorage.getItem("user_name"),
      };
      let formData = new FormData();
      for (let k in data) {
        formData.append(k, data[k]);
      }
      this.$axios({
        method: "POST",
        url: "/request/user.php",
        // url: process.env.VUE_APP_BASE_URL+"/request/user.php",
        data: formData,
      }).then((code) => {
        if (code.data.code == 200) {
          this.$message.success(code?.data?.message || 'Success')
          this.countdown = 60
          this.timer = setInterval(() => {
            this.countdown--
            if (this.countdown <= 0) {
              clearInterval(this.timer)
              this.sendingCode = false
            }
          }, 1000)
        } else {
          this.sendingCode = false
          clearInterval(this.timer);
          this.$message.error(code.data.message);
        }
      }).catch(() => {
        //   this.$message.error('Error')
          this.sendingCode = false
        });
    },

    clickCancel() {
        this.$emit('handleDialog');
        clearInterval(this.timer)
        this.$refs.resetForm.resetFields()
    },

    submitForm() {
      this.$refs.resetForm.validate(valid => {
        if (!valid) return

        let payload = {
          new_password: this.form.newPassword,
          uid: window.localStorage.getItem("uid"),
          type: 'reset_subaccount_password',
          sub_uid: this.subUid
        }

        if (this.activeTab === 'email') {
          payload.email_code = this.form.emailCode
        } else if (this.activeTab === 'authenticator') {
          payload.google_code = this.form.authCode
        }

        resetSubAccountPassword(payload).then(res => {
            if(res.code == 200) {
                this.$message.success(res.message);
                this.$refs.resetForm.resetFields()
                // 关闭窗口
                this.$emit('handleDialog')
            } else {
                this.$message.error(res.message);
            }
        }).catch(() => {
            console.log('error')
        })
      })
    }
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer)
  }
}
</script>

<style scoped>
.el-form-item {
  margin-bottom: 20px;
}
</style>
